class MHeader extends HTMLElement {
    constructor() {
        super(),
            (this.selectors = { headers: ["header"], logos: [".m-logo"], topbar: ".m-topbar", headerWrapper: ".m-header__wrapper", topbarClose: ".m-topbar__close" }),
            (this.domNodes = queryDomNodes(this.selectors, this)),
            (this.innerWidth = window.innerWidth),
            (this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop),
            (this.headerHeight = this.domNodes.headerWrapper.offsetHeight),
            (this.stickyHeader = this.dataset.sticky),
            (this.classes = { scrollUp: "scroll-up", scrollDown: "scroll-down", stuck: "stuck", always: "header-sticky-always", headerScrollUp: "header-scroll-up", headerScrollDown: "header-scroll-down" }),
            this.init();
    }
    init() {
        (this.transparentHeader = this.domNodes && this.domNodes.headers[0] && "true" === this.domNodes.headers[0].dataset.transparent),
            this.initAddon(),
            this.handleSticky(),
            document.addEventListener("matchMobile", () => this.handleSticky()),
            document.addEventListener("unmatchMobile", () => this.handleSticky()),
            (this.siteNav = new SiteNav(this)),
            (window.__sfHeader = this),
            window.addEventListener("resize", () => {
                this.innerWidth = window.innerWidth;
            });
    }
    initAddon() {
        (this.megamenu = new Megamenu(this)), Shopify.designMode && ((MinimogTheme = MinimogTheme || {}), MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount());
    }
    handleSticky() {
  let offsetTop = 20;
  document.querySelectorAll(".shopify-section-group-header-group").forEach((el) => {
    if (!el.classList.contains("m-section-header") && !el.classList.contains("m-section-scaling-logo")) {
      offsetTop += el.offsetHeight;
    }
  });

  const topbar = document.querySelector(".m-topbar");
  if (topbar) {
    offsetTop += topbar.offsetHeight;
  }

  window.addEventListener("scroll", () => {
    const currentScrollTop = window.scrollY;

    if (currentScrollTop > offsetTop) {
      if (this.stickyHeader === "on_scroll_up" || this.stickyHeader === "always") {
        this.classList.add(this.classes.stuck);
      }
    } else {
      this.classList.remove(this.classes.stuck);
    }

    // Remove all scroll-related classes
    this.classList.remove(this.classes.scrollUp, this.classes.scrollDown);
    document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
  });
      // Add this to the end of your handleSticky method
window.addEventListener("scroll", () => {
  if (this.classList.contains(this.classes.stuck)) {
    document.body.classList.add('header-stuck');
  } else {
    document.body.classList.remove('header-stuck');
  }
});
}
}
customElements.define("m-header", MHeader);
